import { LocaleConfig } from 'config/locales';
import en from 'locales/en';
import es from 'locales/es';
import pt from 'locales/pt';
import { useEffect } from 'react';
import { LangObj, LangObjDictionary } from 'types/language';
import { resolveLocaleCode } from 'utils/formatLanguageParam';

const defaultLangObj = en;
const languages: LangObjDictionary = { en, es, pt };

const useLocale = (): LangObj => {
  const locale = resolveLocaleCode();

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  // TODO load language dynamically from the server
  if (LocaleConfig.enabled && locale in languages) return languages[locale];

  return defaultLangObj;
};

export default useLocale;
